import IconMinus from "@/app/(site)/_components/Atoms/Icons/IconMinus"
import IconPlus from "@/app/(site)/_components/Atoms/Icons/IconPlus"
import { isClient } from "@/lib/env-utils/env-utils"
import DynamicLink from "../../../Molecules/Link"

type LoadMoreCardProps = {
    title: string
    onClick?: (
        e: React.MouseEvent<HTMLDivElement> | React.MouseEvent<HTMLAnchorElement>
    ) => void
    href?: string // Optional, used for server-side link
    symbol?: "plus" | "minus"
}

export const LoadMoreCard = ({
    title,
    onClick,
    href,
    symbol = "plus"
}: LoadMoreCardProps) => {
    // Client-side: Handle onClick to load more products
    if (isClient && onClick) {
        return (
            <DynamicLink
                className="next-page-button col-span-6 mb-16 flex aspect-square cursor-pointer items-center justify-center rounded-full border border-black md:col-span-3"
                aria-label={`${title}. Loads more products`}
                href={href || ""}
                onClick={e => {
                    e.preventDefault()
                    onClick(e)
                }}
            >
                <span className="!text-12 md:!text-16">{title}</span>
                {symbol === "plus" ? (
                    <IconPlus className="h-20 w-20" />
                ) : (
                    <IconMinus className="h-20 w-20" />
                )}
            </DynamicLink>
        )
    }

    // Server-side: Use href for SEO and non-JS navigation
    return (
        <DynamicLink
            href={href || ""}
            className="next-page-button col-span-6 mb-16 flex aspect-square cursor-pointer items-center justify-center rounded-full border border-black md:col-span-3"
            aria-label={`${title}. Loads more products`}
        >
            <span className="!text-12 md:!text-16">{title}</span>
            {symbol === "plus" ? (
                <IconPlus className="h-20 w-20" />
            ) : (
                <IconMinus className="h-20 w-20" />
            )}
        </DynamicLink>
    )
}
